import { useState } from 'react';
import { BiPlus } from 'react-icons/bi';

import { ButtonSmall } from '@/components/Button';
import type { SubEventInput } from '@/store/events/events.dto';

import CreateItinerarySheet from './CreateItinerarySheet/CreateItinerarySheet';
import ItineraryItem from './ItineraryItem';
import s from './ItinerarySection.module.scss';

export type SubEvent = SubEventInput;

type Props = {
  subEvents: SubEvent[];
  onChange: (subEvents: SubEvent[]) => void;
};

function ItinerarySection({ subEvents, onChange }: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingIndex, setEditingIndex] = useState<number | null>(null);

  const handleSubmit = (subEvent: SubEvent) => {
    if (editingIndex !== null) {
      onChange(subEvents.map((e, i) => (i === editingIndex ? subEvent : e)));
    } else {
      onChange([...subEvents, subEvent]);
    }
    setEditingIndex(null);
  };

  const handleEdit = (index: number) => {
    setEditingIndex(index);
    setIsModalOpen(true);
  };

  const handleDelete = (index: number) => {
    onChange(subEvents.filter((_, i) => i !== index));
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setEditingIndex(null);
  };

  return (
    <section>
      <div className={s.sectionTitle}>
        <span>Itinerary</span>
      </div>
      <div className={s.itineraryList}>
        {subEvents
          .map((subEvent, i) => ({ subEvent, i }))
          .sort(
            (a, b) =>
              new Date(a.subEvent.time_slot?.start ?? 0).getTime() -
              new Date(b.subEvent.time_slot?.start ?? 0).getTime(),
          )
          .map(({ subEvent, i }) => (
            <ItineraryItem
              key={i}
              subEvent={subEvent}
              onEdit={() => handleEdit(i)}
              onDelete={() => handleDelete(i)}
            />
          ))}
      </div>
      <button type="button" className={s.addItineraryButton} onClick={() => setIsModalOpen(true)}>
        <ButtonSmall type="button" className={s.addButton}>
          <BiPlus size={24} />
        </ButtonSmall>
        Add Itinerary
      </button>
      <CreateItinerarySheet
        open={isModalOpen}
        onClose={handleClose}
        onSubmit={handleSubmit}
        initialData={editingIndex !== null ? subEvents[editingIndex] : undefined}
      />
    </section>
  );
}

export default ItinerarySection;
